'use strict';
const Timeline = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */


	/** @description Initialize */
	init: function() {
		this.timeline();
	},

	timeline: () => {
		const items = document.querySelectorAll('.timeline__item');

		function isElementInViewport(el) {
			const rect = el.getBoundingClientRect();
			return (
				rect.top >= 0 &&
				rect.left >= 0 &&
				rect.bottom <=
				(window.innerHeight || document.documentElement.clientHeight) &&
				rect.right <= (window.innerWidth || document.documentElement.clientWidth)
			);
		}

		function callbackFunc() {
			for (let i = 0; i < items.length; i++) {
				if (isElementInViewport(items[i])) {
					items[i].classList.add('in-view');
				}
			}
		}

		window.addEventListener('load', callbackFunc);
		window.addEventListener('resize', callbackFunc);
		window.addEventListener('scroll', callbackFunc);
	}
};

export default Timeline;
